export const API_URL = 'buffers/division'
export const ROUTE_NAME = 'buffers/division'
